import { Texture, Sprite, Container, utils } from 'pixi.js';
import { InteractionEvents, Tween, LoaderDisplay, StageBackground } from "@cc/pixi-app";
import { env, app } from ".";
import { LoadScreen } from "./loader";

/**
 * GameLoader - This class is used by PixiApp screen manager
 * to show asset loading progress. It's created as container on top
 * to allow for transition in and out.
 *
 * See LoaderDisplay class in PixiApp for more details on how it's used.
 *
 */

let first = true;

export class PreloadScreen extends LoaderDisplay {
    constructor() {
        super();

        this.autoProgress = true;

        this.loadProgress = 0;
        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_LOADING_START
        );

        if (env.params.showStartButton) {
            this.startButton = new Sprite();
            this.startButton.texture = Texture.WHITE;
            this.startButton.visible = false;
            this.startButton.tint = 0x00ff00;
            this.startButton.width = 256;
            this.startButton.height = 256;
            this.startButton.anchor.set(0.5);
            this.addChild(this.startButton);
        }

        this.background = new Sprite.from('hills_bg');
        this.background.height = app.resizer.height;
        this.background.scale.x = this.background.scale.y;
        this.background.anchor.set(0.5);
        this.addChild(this.background);

        this.light = new Sprite.from('light_beams');
        this.light.anchor.set(0.5);
        this.light.y = 170;
        this.light.scale.set(2.1);
        this.background.addChild(this.light);

        this.logo = new Sprite.from('brand-logo');
        this.logo.anchor.set(0.5);
        this.logo.scale.set(1);
        this.logo.y = -200;
        this.addChild(this.logo);

        // Loading bar
        this.lb = new Container();
        this.lb.y = 256;
        this.addChild(this.lb);

        this.lb.back = Sprite.from('bar-back');
        this.lb.back.anchor.set(0.5);
        this.lb.addChild(this.lb.back);

        // Progress bar
        this.pb = new Container();
        this.pb.y -= 7;
        this.pb.indent = 64;
        this.pb.colour = 0xe65c00;
        this.lb.addChild(this.pb);

        this.pb.start = Sprite.from('bar-fill');
        this.pb.start.anchor.set(1, 0.5);

        this.pb.end = Sprite.from('bar-fill');
        this.pb.end.anchor.set(1, 0.5);
        this.pb.end.scale.x = -1;

        this.pb.fill = new Sprite();
        this.pb.fill.texture = Texture.WHITE;
        this.pb.fill.tint = this.pb.colour;
        this.pb.fill.width = 0;
        this.pb.fill.height = 128;
        this.pb.fill.anchor.set(0, 0.5);

        this.pb.length = this.lb.back.width - this.pb.indent - this.pb.start.width - this.pb.end.width;
        this.pb.height = this.pb.start.height;
        this.pb.start.x = -this.pb.length * 0.5;
        this.pb.fill.x = this.pb.start.x;
        this.pb.end.x = this.pb.fill.x + this.pb.fill.width - 1;
        this.pb.addChild(this.pb.start, this.pb.fill, this.pb.end);
    }

    /**
     * @param {loaders.Loader} loader
     * @param {loaders.Resource} resource
     */

    onProgress(loader, resource) {
        this.loadProgress = loader.progress / 100;

        this.pb.fill.width = this.pb.length * this.loadProgress;
        this.pb.end.x = this.pb.fill.x + this.pb.fill.width - 1;
    }

    /**
     * @param {loaders.Loader} loader
     * @param {loaders.Resource} resource
     */
    onComplete(loader, resource) {
        if (!this.autoProgress) {
            this.logo.visible = false;
            this.lb.visible = false;
            this.light.visible = false;
            this.background.visible = false;

            if (env.params.showStartButton) {
                this.startButton.once("pointertap", () => {
                    if (utils.isMobile.android.device)
                        this.app.requestFullscreen();
                    this.startButton.interactive = false;
                    this.startButton.destroy();
                    // this.app.showScreen('splash');
                });
                this.startButton.interactive = true;
                this.startButton.visible = true;
            }
            else {
                // this.app.showScreen('splash');
            }
        }
        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_LOADING_END
        );
    }

    transitionIn(resolve) {
        resolve();
    }

    transitionOut(resolve) {

        resolve();
    }
}

